import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * Stats-table cell that reveals a "View details" expand affordance on hover (FTK-7117).
 *
 * Renders the numeric value right-aligned; when `clickable` and hovered, the value + an expand
 * icon sit inside a lavender rounded box with a centered label above. Used in any Spacetime table
 * whose transaction-stat cell opens the Transaction detail overlay (Portfolio / Marketing /
 * Campaigns / Audience), so the trigger looks identical everywhere.
 *
 * Purely presentational — the actual open is wired via the column's `onClick` in the host table.
 * Project anything that should sit UNDER the value (e.g. `<ft-yoy-delta>`) into the default slot.
 */
@Component({
    selector: 'ft-stat-expand-cell',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './stat-expand-cell.component.html',
    styleUrls: ['./stat-expand-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatExpandCellComponent {
    /** Numeric value to display. */
    @Input() value: number | null = null;
    /** Angular number-pipe digitsInfo for the value. */
    @Input() digitsInfo = '1.0-0';
    /** Whether this cell can be drilled into — gates the hover box + expand icon. */
    @Input() clickable = false;
    /** Hover label shown above the box. */
    @Input() label = 'View details';
}
